<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="true"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <Form
          ref="personalInfoForm"
          :model="personalInfoForm"
          :rules="personalRule"
        >
          <div class="personal-info card">
            <div class="card-header">
              个人信息
            </div>
            <div class="card-body">
              <row :gutter="80">
                <i-col span="18">
                  <row :gutter="80" class="form-item-group">
                    <i-col span="12">
                      <FormItem label="姓名" prop="userName">
                        <AutoComplete
                          v-model="personalInfoForm.userName"
                          placeholder="请输入姓名"
                          :disabled="isDisable"
                          @on-search="userNameSearchHandler"
                        >
                          <div
                            class="user-name-item"
                            v-for="item in userNames"
                            :key="item.id"
                            @click="userNameItemHandler(item)"
                          >
                            {{ item.realName }}
                          </div>
                        </AutoComplete>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="派驻类别" prop="partyTypeList">
                        <Cascader
                          v-model="partyTypePlaceholder"
                          :data="partyTypeLocalList"
                          placeholder="请选择"
                          clearable
                          @on-change="partyTypeChange"
                          change-on-select
                        ></Cascader>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="联系电话" prop="phoneNO">
                        <Input
                          v-model="personalInfoForm.phoneNO"
                          placeholder="请输入联系电话"
                        />
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="政治面貌" prop="politicalType">
                        <Select
                          v-model="personalInfoForm.politicalType"
                          clearable
                        >
                          <Option
                            v-for="item in politicalList"
                            :key="item.index"
                            :value="item.index"
                            :label="item.status"
                          ></Option>
                        </Select>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="性别" prop="sex">
                        <Select v-model="personalInfoForm.sex" clearable>
                          <Option
                            v-for="item in genderList"
                            :key="item.index"
                            :value="item.index"
                            :label="item.status"
                          ></Option>
                        </Select>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="工作单位" prop="workPlace">
                        <Input
                          v-model="personalInfoForm.workPlace"
                          placeholder="请输入工作单位"
                        />
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="职务" prop="position">
                        <Input
                          v-model="personalInfoForm.position"
                          placeholder="请输入职务"
                        />
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem label="职级" prop="rank">
                        <Select v-model="personalInfoForm.rank" clearable>
                          <Option
                            v-for="item in rankList"
                            :key="item.id"
                            :value="item.dicIndex"
                            :label="item.dicName"
                          ></Option>
                        </Select>
                      </FormItem>
                    </i-col>
                  </row>
                </i-col>
                <i-col span="6">
                  <FormItem label="个人照片" prop="headPicUrl">
                    <upl-img-act
                      :imgArr="imgArr"
                      :imgNumber="imgNumber"
                      :fixedNumber="fixedNumber"
                      :imgHeight="100"
                      :imgWidth="100"
                      @saveImg="saveImg"
                      @delPic="delImg"
                      class="upload"
                    >
                      <div class="uploadbox">
                        <i class="iconfont icon-shangchuan1"></i>
                        <p>上传图片</p>
                      </div>
                    </upl-img-act>
                    <!-- <input type="text" v-model="personalInfoForm.headPicUrl" /> -->
                  </FormItem>
                </i-col>
              </row>
            </div>
          </div>
        </Form>
        <Form ref="serverCompanyForm" :model="serverCompanyForm">
          <div class="serve-company card">
            <div class="card-header">
              服务企业
            </div>
            <div class="card-body">
              <row :gutter="80">
                <i-col
                  span="24"
                  v-for="(company, index) in serverCompanyForm.companyList"
                  :key="index"
                >
                  <div class="card-title">
                    服务企业{{ index + 1 }}
                    <span class="error" @click="delCompany(company)"
                      ><Icon type="ios-close-circle"
                    /></span>
                  </div>
                  <row class="form-item-group" :gutter="80">
                    <i-col span="12">
                      <FormItem
                        label="企业名称"
                        :prop="'companyList.' + index + '.companyName'"
                        :rules="{ required: true, message: '企业名称不能为空' }"
                      >
                        <Input
                          v-model="company.companyName"
                          placeholder="请输入企业名称"
                        />
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem
                        label="企业类别"
                        :prop="'companyList.' + index + '.companyType'"
                        :rules="{ required: true, message: '企业类别不能为空' }"
                      >
                        <Select v-model="company.companyType" clearable>
                          <Option
                            v-for="item in companyTypeList"
                            :key="item.id"
                            :value="item.dicIndex"
                            :label="item.dicName"
                          ></Option>
                        </Select>
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem
                        label="企业所在地"
                        :prop="'companyList.' + index + '.companyPlace'"
                        :rules="{
                          required: true,
                          message: '企业所在地不能为空'
                        }"
                      >
                        <Input
                          v-model="company.companyPlace"
                          placeholder="请输入企业所在地"
                        />
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem
                        label="联系人"
                        :prop="'companyList.' + index + '.name'"
                        :rules="{ required: true, message: '联系人不能为空' }"
                      >
                        <Input
                          v-model="company.name"
                          placeholder="请输入联系人"
                        />
                      </FormItem>
                    </i-col>
                    <i-col span="12">
                      <FormItem
                        label="联系电话"
                        :prop="'companyList.' + index + '.phoneNO'"
                        :rules="[
                          { required: true, message: '联系电话不能为空' },
                          {
                            type: 'number',
                            validator: (rule, value, callback) => {
                              if (!/^1[3456789]\d{9}$/.test(value)) {
                                callback('手机号码有误，请重填!');
                                return false;
                              } else {
                                return true;
                              }
                            }
                          }
                        ]"
                      >
                        <Input
                          v-model="company.phoneNO"
                          placeholder="请输入联系电话"
                        />
                      </FormItem>
                    </i-col>
                  </row>
                </i-col>
              </row>
            </div>
          </div>
        </Form>
        <Button class="bkcc-btn del-btn" icon="ios-add" @click="addCompany"
          >新增企业</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import uplImgAct from "../../../components/uplImgAct";
import api from "../../../api/index";
const { postChiefWaiter, getChiefWaiterDetail, postChiefWaiterUserList } = api;
import { getPartyTypeDic, getRankDic, getCompanyTypeDic } from "./dic";
export default {
  name: "addChiefWaiter",
  components: {
    pageHead,
    uplImgAct
  },
  data() {
    return {
      title: "用户管理",
      isDisable: false,
      btnList: [
        {
          name: "保存",
          type: "save"
        }
      ],
      politicalList: [
        {
          index: 0,
          status: "群众"
        },
        {
          index: 1,
          status: "党员"
        },
        {
          index: 2,
          status: "预备党员"
        }
      ],
      genderList: [
        {
          index: 0,
          status: "未知"
        },
        {
          index: 1,
          status: "男"
        },
        {
          index: 2,
          status: "女"
        }
      ],
      userNames: [],
      rankList: [],
      partyTypeLocalList: [],
      companyTypeList: [],
      imgArr: [],
      imgNumber: 1,
      fixedNumber: [1, 1],
      partyTypePlaceholder: [],
      personalInfoForm: {
        id: "",
        unionId: "",
        userName: "",
        partyTypeList: "",
        partyType: "",
        phoneNO: "",
        politicalType: "",
        sex: "",
        workPlace: "",
        position: "",
        rank: "",
        headPicUrl: ""
      },
      personalRule: {
        userName: [{ required: true, message: "姓名不能为空" }],
        partyTypeList: [{ required: true, message: "派驻类别不能为空" }],
        phoneNO: [
          {
            required: true,
            message: "联系电话不能为空"
          },
          {
            type: "number",
            validator: (rule, value, callback) => {
              if (!/^1[3456789]\d{9}$/.test(value)) {
                callback("手机号码有误，请重填!");
                return false;
              } else {
                return true;
              }
            }
          }
        ],
        politicalType: [{ required: true, message: "政治面貌不能为空" }],
        sex: [{ required: true, message: "性别不能为空" }],
        workPlace: [{ required: true, message: "工作单位不能为空" }],
        position: [{ required: true, message: "职务不能为空" }],
        rank: [{ required: true, message: "职级不能为空" }],
        headPicUrl: [{ required: true, message: "个人照片不能为空" }]
      },
      serverCompanyForm: {
        companyList: [
          {
            companyName: "",
            companyType: "",
            companyPlace: "",
            name: "",
            phoneNO: ""
          }
        ]
      }
    };
  },
  // watch: {
  //   "serverCompanyForm.companyList"() {
  //     this.$nextTick(this.$refs["serverCompanyForm"].validate);
  //   }
  // },
  methods: {
    handleBtn(type) {
      const handler = this[type + "Handler"];
      handler && handler();
    },
    // 保存信息
    saveHandler() {
      // console.log(this.personalInfoForm, this.serverCompanyForm);
      if (this.personalInfoForm.unionId === "") {
        this.$Message.error("该用户未在濮阳小程序中登录，请核实");
        return false;
      }
      if (!this.serverCompanyForm.companyList) {
        this.$Message.error("至少填写一家服务企业");
        return false;
      }
      const personalFormIsValidated = this.isValidated("personalInfoForm");
      const serverCompanyFormIsValidated = this.isValidated(
        "serverCompanyForm"
      );
      Promise.all([personalFormIsValidated, serverCompanyFormIsValidated]).then(
        value => {
          const isPass = value.every(item => item === true);
          if (isPass) {
            const formData = {
              ...this.personalInfoForm,
              ...this.serverCompanyForm
            };
            console.log("我是保存");
            // console.log(formData);
            this.$Message.success("保存成功");
            this.$post(postChiefWaiter, formData);
            this.$router.push({ name: "waiterManager" });
          } else {
            this.$Message.error("验证不通过，请检查");
          }
        }
      );
    },
    // 触发自动补全
    async userNameSearchHandler(value) {
      // console.log("看看触发条件是什么： ", value);
      this.userNames = await this.queryUserList(value);
    },
    // 补全信息用户被点击时
    userNameItemHandler(user) {
      // console.log("被电击的用户：", user);
      this.fillHandler(this.personalInfoForm, user);
      this.serverCompanyForm.companyList = user.companyList
        ? user.companyList
        : [
            {
              companyName: "",
              companyType: "",
              companyPlace: "",
              name: "",
              phoneNO: ""
            }
          ];
      this.imgArr = [{ path: user.headPicUrl }];
      this.partyTypePlaceholder = user.partyTypeList
        ? user.partyTypeList.split(",")
        : [];
      this.personalInfoForm.userName = user.realName;
    },
    // 查询已经认证用户
    async queryUserList(name) {
      const res = await this.$post(postChiefWaiterUserList, {
        pageNum: 1,
        pageSize: 10,
        userName: name
      });
      // console.log(res);
      if (res.isSucceed) {
        return res.rows;
      } else {
        return [];
      }
    },
    // 验证表单
    isValidated(formName) {
      return this.$refs[formName].validate(valid => valid);
    },
    // 驻派类别变更时
    partyTypeChange(value) {
      // console.log("驻派类别数据发生变化 ", value);
      this.personalInfoForm.partyTypeList = value.join(",");
      this.personalInfoForm.partyType = value[value.length - 1];
      this.$refs.personalInfoForm.validateField("partyTypeList");
    },
    // 新增企业
    addCompany() {
      this.serverCompanyForm.companyList.push({
        companyName: "",
        companyType: "",
        companyPlace: "",
        name: "",
        phoneNO: ""
      });
    },
    // 删除企业
    delCompany(item) {
      const len = this.serverCompanyForm.companyList.length;
      if (len === 1) {
        this.$Message.warning("服务企业不能为空");
        return false;
      }
      const index = this.serverCompanyForm.companyList.indexOf(item);
      if (index !== -1) {
        this.serverCompanyForm.companyList.splice(index, 1);
      }
    },
    // 上传图片
    saveImg(value) {
      this.imgArr = [value];
      // console.log("看看上传图片数据：", value);
      this.personalInfoForm.headPicUrl = this.imgArr[0].path;
      this.$refs.personalInfoForm.validateField("headPicUrl");
    },
    delImg() {
      this.personalInfoForm.headPicUrl = "";
      this.$refs.personalInfoForm.validateField("headPicUrl");
      this.imgArr = [];
    },
    // 获取职级
    async getRankList() {
      const res = await this.$get(getRankDic);
      this.rankList = res.rows || [];
    },
    // 获取企业类型
    async getCompanyTypeList() {
      const res = await this.$get(getCompanyTypeDic);
      // console.log(res.rows);
      this.companyTypeList = res.rows || [];
    },
    // 获取驻派类别
    async getPartyTypeList() {
      const res = await this.$get(getPartyTypeDic);
      this.partyTypeLocalList = res.rows.length
        ? this.formateData(res.rows)
        : [];
    },
    // 格式化驻派类别数据
    formateData(data) {
      let returnData = data.map(item => {
        return {
          value: item.dicType,
          label: item.dicName,
          children: item.children.length ? this.formateData(item.children) : []
        };
      });
      return returnData;
    },
    // 数据初始化
    async initData() {
      try {
        const { id } = this.$route.query;
        let res = await this.$get(getChiefWaiterDetail(id));
        if (res.isSucceed && res.rows) {
          const dataInfo = res.rows[0];
          this.fillHandler(this.personalInfoForm, dataInfo);
          this.serverCompanyForm.companyList = dataInfo.companyList
            ? dataInfo.companyList
            : [
                {
                  companyName: "",
                  companyType: "",
                  companyPlace: "",
                  name: "",
                  phoneNO: ""
                }
              ];
          this.imgArr = [{ path: dataInfo.headPicUrl }];
          this.partyTypePlaceholder = dataInfo.partyTypeList
            ? dataInfo.partyTypeList.split(",")
            : [];
          // console.log("输出详细信息：", dataInfo);
        }
      } finally {
      }
    },
    // 回填数据函数
    fillHandler(obj, data) {
      Object.keys(obj).map(key => {
        obj[key] = data[key];
      });
    }
  },
  created() {
    if (this.$route.query.id) {
      this.initData();
      this.isDisable = true;
    } else {
      this.isDisable = false;
    }
    this.getPartyTypeList();
    this.getRankList();
    this.getCompanyTypeList();
  }
};
</script>

<style scoped lang="less">
.content {
  margin: 20px;
}
.card {
  background-color: white;
  border-radius: 5px;
  margin-bottom: 20px;
  .card-header {
    padding: 20px;
    border-bottom: 1px solid #dedede;
  }
  .card-body {
    padding: 20px;
    .card-title {
      color: #ff7c44;
    }
  }
}
.detail {
  color: #666;
}
.user-name-item {
  padding: 2px 4px;
}
.headPicUrl {
  // display: block;
  height: 80px;
  width: 80px;
  margin-bottom: 20px;
  margin-right: 10px;
}
.success {
  color: #ff7b44;
}
/deep/ .ivu-form-item {
  display: flex;
}

/deep/ .ivu-form-item-label {
  color: #9a9a9a;
  flex: 0 1 90px;
  text-align: left;
}
/deep/ .ivu-form-item-content {
  flex: 1;
}
.uploadbox {
  width: 100px;
  height: 100px;
  border: 1px dashed #ddd;
  color: #b5b5b5;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  padding: 10px 0;
  font-size: 14px;
  .icon-shangchuan1 {
    display: block;
    font-size: 37px;
  }
}
</style>
